import { render, staticRenderFns } from "./StatusFormItem.vue?vue&type=template&id=4af38981&"
import script from "./StatusFormItem.vue?vue&type=script&lang=js&"
export * from "./StatusFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports